export default __webpack_public_path__ + "static/studyoffice-lounge5-94023805aef8fae62e4c1343f3165549.jpg";